import { WorkInterventionDaysRepository } from "@/api/Repositories";
import { ShutDownBlocksRepository } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    list (state, data) {
      state.list = []
      state.list = data
    },
  },
  actions: {
    list ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        WorkInterventionDaysRepository.get(obj)
          .then(response => {
            const data = response.data.data.wind_turbine_shutdown_blocks
            commit('list', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    create (context, intervention) {
      return new Promise((resolve, reject) => {
        ShutDownBlocksRepository.create(intervention)
          .then((response) => {
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    edit (context, intervention) {      
      return new Promise((resolve, reject) => {
        ShutDownBlocksRepository.update(intervention)
          .then(() => {
            resolve();
          }).catch(errorEdit => {
            reject(errorEdit);
          });
      });
    },
    delete (context, id) {
      return new Promise((resolve, reject) => {
        ShutDownBlocksRepository.delete(id)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    }
  }
}
